import { EZCheckValidator, getDealerDetails, getDealerSignedPhotos, getDealerStoreDetails, getOCRStepFunctionDetailsV2, getTransferCount, onCallEmailNotFound, onManuallyRequestReview } from '@/api/apis';
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { call, delay, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { defaultDetailsDetails, ezCheckInitiateTransfer, setDealerDetails, setDealerStoreDetailsFailure, setDealerStoreDetailsSuccess, setEZCheckForTransferCreationMessage, setEZCheckStatusTransferCreation, setIsEZCheckForTransferCreationInProgress, setisTransferCreationAllowed, setIsTransferReinitiateAllowed, toggleLoading, setIsEmailNotFoundLoading, setCallOcrStepFunctionApi, setIsValidationMaxAPIStop, setOcrStepFunctionStatusV2, setIsOCRLoading, setIsManualReviewLoading, setIsManualReviewRequested } from './slice';
import { DealerProfileType, TransferCountType } from '@masterffl/dealer-profile-component';
import { setTransferCount } from '@/dealerProfile/ducks/slice';
import { AnyAction } from 'redux-saga';
import { RootState } from '@/redux/store';

function* runEZCheckForTransferCreation(
  action: PayloadAction<ezCheckInitiateTransfer>
) {
  try {
    
    yield put(setIsEZCheckForTransferCreationInProgress(true));
    yield put(setisTransferCreationAllowed(false));
    yield put(setIsTransferReinitiateAllowed(false));
    const response: AxiosResponse<{ status: string }> = yield call(
      EZCheckValidator,
      { license_key: action.payload.license_key as string }
    );
    if (
      response.data.status &&
      (response.data.status === '0' || response.data.status === '2')
    ) {
      if (action.payload.isReinitiate)
        yield put(setIsTransferReinitiateAllowed(true));
      else yield put(setisTransferCreationAllowed(true));
    }
    yield put(setEZCheckStatusTransferCreation(response.data.status || '1'));
    yield put(setEZCheckForTransferCreationMessage(null));
  } catch (error) {
    const err = error as AxiosError<{ Error: string }>;
    console.log('error', err);
    yield put(
      setEZCheckForTransferCreationMessage(err?.response?.data?.Error as string)
    );
    yield put(setEZCheckStatusTransferCreation('1'));
  } finally {
    yield put(setIsEZCheckForTransferCreationInProgress(false));
  }
}

function* callToGetDealerDetail(action: PayloadAction<string>) {
  try {
    yield put(setDealerDetails(defaultDetailsDetails));
    callToToggleLoading();
    const response: AxiosResponse<{
      data: DealerProfileType;
    }> = yield call(getDealerDetails, action.payload);
    if (response?.status == 200) {
      // const signedResponse: AxiosResponse<string[]> = yield call(
      //   getDealerSignedPhotos,
      //   response.data.data.primaryInboundDetails.licenseKey
      // );
      // response.data.data.businessDetails.photos = signedResponse.data;
      response.data.data.primaryInboundDetails.slugForSEO = response?.data?.data?.primaryInboundDetails?.slugForSEO ? `https://${import.meta.env.VITE_MYFFL_BASE_URL}/${response?.data?.data?.primaryInboundDetails?.slugForSEO}` : null 
      callToToggleLoading();
      yield put(setDealerDetails(response.data.data));
    }
  } catch (error) {
    console.log('error', error);
  }
}

function* callToTransferCount(action: PayloadAction<string>) {
  try {
    callToToggleLoading();
    const response: AxiosResponse<TransferCountType> = yield call(getTransferCount, action.payload);
    if (response?.status == 200) {
      callToToggleLoading();
      yield put(setTransferCount(response?.data));
    }
  } catch (error) {
    console.log('error', error);
  }
}

function* callToGetDealerStoreDetails(action: PayloadAction<string>) {
  try {
    const data: unknown = yield call(getDealerStoreDetails, action.payload);
    yield put(setDealerStoreDetailsSuccess(data));
  } catch (error) {
    console.error('Error fetching dealer store details for opt-in settings', error);
    yield put(setDealerStoreDetailsFailure());
  }
}

function* callToToggleLoading() {
  toggleLoading();
}

function* callToEmailNotFound(action: PayloadAction<string>) {
  try {
    yield put(setIsEmailNotFoundLoading(true));
    const response: AxiosResponse<any> = yield call(onCallEmailNotFound, action.payload);
    if (response?.status == 200) {
      localStorage.setItem('emailNotFound', 'true');
      yield put(setIsEmailNotFoundLoading(false));
    }
    yield put(setIsEmailNotFoundLoading(false));
  } catch (error) {
    console.log('error', error);
    yield put(setIsEmailNotFoundLoading(false));
  }
}

function* callToGetOCRStepFunctionDetailsV2(action: AnyAction) {
  // @ts-ignore
  let isOCRStepFunctionNeedToCall = yield select(
    (state: RootState) => state.dealer.callOcrStepFunctionApi
  );
  let count = 0;
  while (isOCRStepFunctionNeedToCall) {
    try {
      count = count + 1;
      if(count === 200){
        yield put(setCallOcrStepFunctionApi(false));
        yield put(setIsOCRLoading(false));
        yield put(setIsValidationMaxAPIStop(true));
        throw new Error("Validation failed!");
      }
      
      // @ts-ignore
      const response = yield call(getOCRStepFunctionDetailsV2, action.payload);

      if (response.status === 204 || response.status === 200) {
        yield put(setIsOCRLoading(false));
        yield put(setOcrStepFunctionStatusV2(response.data));
        if (response.status === 204) {
          yield put(setCallOcrStepFunctionApi(false));
        }
      }
    } catch (e) {
      console.log(String(e));
      
    } finally {
      yield delay(2000);
      // @ts-ignore
      isOCRStepFunctionNeedToCall = yield select(
        (state: RootState) => state.dealer.callOcrStepFunctionApi
      );
    }
  }
}

function* callToManualReviewRequest(
  action: PayloadAction<{ clientDocumentId: string }>
) {
  try {
    yield put(setIsManualReviewLoading(true));
    const response: AxiosResponse<{ status: number }> = yield call(onManuallyRequestReview, action.payload);
    if (response.status === 200) {
      yield put(setIsManualReviewRequested(true));
    }
    yield put(setIsManualReviewLoading(false));
  } catch (e: any) {
    console.log({ Error: String(e) });
    yield put(setIsManualReviewLoading(false));
  }
}

function* watchCallToGetDealerDetail() {
  yield takeEvery('dealer/callToGetDealerDetail', callToGetDealerDetail);
}

function* watchCallToTransferCount() {
  yield takeEvery('dealer/callToTransferCount', callToTransferCount);
}

function* watchCallToToggleLoading() {
  yield takeEvery('dealer/callToToggleLoading', callToToggleLoading);
}
function* watchcallToEZCheckForTransferCreation() {
  yield takeEvery(
    'dealer/callToEZCheckForTransferCreation',
    runEZCheckForTransferCreation
  );
}
function* watchCallToEmailNotFound() {
  yield takeEvery('dealer/callToEmailNotFound', callToEmailNotFound);
}
function* watchForCallToGetOCRStepFunctionDetailsV2() {
  yield takeEvery("dealer/callToGetOCRStepFunctionDetailsV2", callToGetOCRStepFunctionDetailsV2);
}
function* watchCallToManualReviewRequest() {
  yield takeEvery('dealer/callToManualReviewRequest', callToManualReviewRequest);
}

function* watchCallToGetDealerStoreDetails() {
  yield takeLatest('dealer/callToGetDealerStoreDetails', callToGetDealerStoreDetails);
}

export {
  watchCallToGetDealerDetail,
  watchCallToToggleLoading,
  watchcallToEZCheckForTransferCreation,
  watchCallToTransferCount,
  watchCallToEmailNotFound,
  watchForCallToGetOCRStepFunctionDetailsV2,
  watchCallToManualReviewRequest,
  watchCallToGetDealerStoreDetails
};
